import { Action } from "../../../libs/redux/action";
import { EmissionState } from "../state";
import {
    SAVE_EMISSION,
    SAVE_EMISSION_DONE,
    START_EMISSION,
    START_EMISSION_DONE,
} from "../constants";
import { StartIssuanceResponse } from "../../../containers/quotation/types/emission";

export class StartEmission extends Action<
    { idTransaction: number; quoteCode: string },
    EmissionState
> {
    readonly type = START_EMISSION;

    reducer(state: EmissionState): EmissionState {
        return {
            ...state,
        };
    }
}

export class StartEmissionDone extends Action<any, EmissionState> {
    readonly type = START_EMISSION_DONE;

    reducer(state: EmissionState): EmissionState {
        if (this.error) {
            return {
                ...state,
            };
        }

        const { numberQuotes, ...startIssuanceResponse } = this.payload;

        return {
            ...state,
            startIssuance: startIssuanceResponse as StartIssuanceResponse,
            numberQuotes,
        };
    }
}

export class SaveEmission extends Action<any, EmissionState> {
    readonly type = SAVE_EMISSION;

    reducer(state: EmissionState): EmissionState {
        return {
            ...state,
            loadingSafetyPayCode: true,
        };
    }
}

export class SaveEmissionDone extends Action<
    EmissionState["registerResponse"] | Error,
    EmissionState
> {
    readonly type = SAVE_EMISSION_DONE;

    reducer(state: EmissionState): EmissionState {
        if (this.error) {
            return {
                ...state,
                loadingSafetyPayCode: false,
            };
        }

        return {
            ...state,
            registerResponse: this.payload as EmissionState["registerResponse"],
            loadingSafetyPayCode: false,
        };
    }
}
